import API from './api';
import { E2ELoginResult, User } from '../types';

export const login = async (email: string, password: string): Promise<User> => {
  const response = await API({ feedbackMode: 'off' }).post('/auth/login', { email, password });
  console.log('login response', response);
  localStorage.setItem('token', response.data.token);
  return response.data.user;
};

export const signup = async (name: string, email: string, password: string): Promise<User> => {
  const response = await API().post('/auth/signup', { name, email, password });
  localStorage.setItem('token', response.data.token);
  return response.data.user;
};

export const logout = (): void => {
  localStorage.removeItem('token');
  // TODO: Clear server session?
};

export const exchangeOAuthCode = async (code: string): Promise<User> => {
  const response = await API({ feedbackMode: 'on' }).get(`/auth/oauth/exchange?code=${code}`);
  localStorage.setItem('token', response.data.token);
  return response.data.user;
};

export const e2eLogin = async (email?: string | null, redirect?: string | null): Promise<E2ELoginResult> => {
  const params = new URLSearchParams();
  if (email) params.set('email', email);
  if (redirect) params.set('redirect', redirect);

  const query = params.toString();
  const response = await API({ feedbackMode: 'off' }).get(`/auth/e2e-login${query ? `?${query}` : ''}`);
  localStorage.setItem('token', response.data.token);
  return response.data;
};
